import { render, staticRenderFns } from "./service-endpoint-card.vue?vue&type=template&id=f44c6478&scoped=true"
import script from "./service-endpoint-card.vue?vue&type=script&lang=js"
export * from "./service-endpoint-card.vue?vue&type=script&lang=js"
import style0 from "./service-endpoint-card.vue?vue&type=style&index=0&id=f44c6478&prod&scoped=true&lang=css"
import style1 from "./service-endpoint-card.vue?vue&type=style&index=1&id=f44c6478&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44c6478",
  null
  
)

export default component.exports